module.exports = __webpack_public_path__ + "static/media/Plus.1838240f.svg";